/*
 * Wunderbox: efectos de la "vitrina de coleccionista".
 *  1. Brillo holográfico + inclinación 3D en tarjetas de producto (solo con puntero fino).
 *  2. Interruptor "Solo disponibles" en las colecciones (recuerda la preferencia).
 * Todo es opcional: si falla algo, la tienda funciona igual.
 */
(function () {
  'use strict';

  /* ---------- 1. Holo + tilt ---------- */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (canHover && !reduceMotion) {
    var active = null;
    var frame = null;
    var lastEvent = null;

    var paint = function () {
      frame = null;
      if (!active || !lastEvent) return;
      var rect = active.getBoundingClientRect();
      var x = (lastEvent.clientX - rect.left) / rect.width;
      var y = (lastEvent.clientY - rect.top) / rect.height;
      x = Math.min(Math.max(x, 0), 1);
      y = Math.min(Math.max(y, 0), 1);
      active.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
      active.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      active.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
      active.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
    };

    var reset = function (el) {
      el.style.removeProperty('--mx');
      el.style.removeProperty('--my');
      el.style.removeProperty('--rx');
      el.style.removeProperty('--ry');
    };

    document.addEventListener(
      'pointermove',
      function (event) {
        var target = event.target && event.target.closest ? event.target.closest('.card-wrapper') : null;
        if (target !== active) {
          if (active) reset(active);
          active = target && !target.classList.contains('wb-card--sold-out') ? target : null;
        }
        if (!active) return;
        lastEvent = event;
        if (!frame) frame = window.requestAnimationFrame(paint);
      },
      { passive: true }
    );

    document.addEventListener(
      'pointerleave',
      function () {
        if (active) reset(active);
        active = null;
      },
      true
    );
  }

  /* ---------- 2. Solo disponibles ---------- */
  var KEY = 'wb_only_available';
  var root = document.documentElement;

  function readPref() {
    try {
      return window.localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writePref(on) {
    try {
      window.localStorage.setItem(KEY, on ? '1' : '0');
    } catch (e) {}
  }

  function syncButtons() {
    var on = root.classList.contains('wb-only-available');
    document.querySelectorAll('[data-wb-only-available]').forEach(function (btn) {
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  if (readPref()) root.classList.add('wb-only-available');

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-wb-only-available]') : null;
    if (!btn) return;
    var on = root.classList.toggle('wb-only-available');
    writePref(on);
    syncButtons();
  });

  // Los filtros de Shopify vuelven a dibujar la cuadrícula: reaplicamos el estado del botón.
  new MutationObserver(syncButtons).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', syncButtons);
  syncButtons();
})();
